const TestPackageIndex = () =>
  import("@/pages/lab/testpackage/TestPackageIndex");
const TestPackageSingle = () =>
  import("@/pages/lab/testpackage/TestPackageSingle");
const TestPackageDetail = () =>
  import("@/pages/lab/testpackage/TestPackageDetail");
const TestPackageAdd = () => import("@/pages/lab/testpackage/TestPackageAdd");
const TestPackageEdit = () => import("@/pages/lab/testpackage/TestPackageEdit");
const TestPackageSort = () => import("@/pages/lab/testpackage/TestPackageSort");
const TestPackageGroupSort = () =>
  import("@/pages/lab/testpackagegroup/TestPackageGroupSort");

export class TestPackageRoutes {
  constructor() {
    this.route_root = "testpackages";
    this.type_single = "Test Package";
    this.type_plural = "Test Packages";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: TestPackageIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "sort",
            name: `Sort ${this.type_plural}`,
            component: TestPackageSort,
            meta: { requiresAuth: true }
          },
          {
            path: "group-sort",
            name: `Sort ${this.type_single} Groups`,
            component: TestPackageGroupSort,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: TestPackageAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":test_package_id",
            component: TestPackageSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: TestPackageDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: TestPackageEdit,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
